/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AustralianStateCode {
  ACT = "ACT",
  NSW = "NSW",
  NT = "NT",
  QLD = "QLD",
  SA = "SA",
  TAS = "TAS",
  VIC = "VIC",
  WA = "WA",
}

export enum DeliveryType {
  EMAIL = "EMAIL",
  NONE = "NONE",
  POSTAL_MAIL = "POSTAL_MAIL",
}

export enum LevelType {
  BASEMENT = "BASEMENT",
  FLOOR = "FLOOR",
  GROUND_FLOOR = "GROUND_FLOOR",
  LEVEL = "LEVEL",
  LOWER_GROUND = "LOWER_GROUND",
  MEZZANINE = "MEZZANINE",
  UPPER_GROUND = "UPPER_GROUND",
}

export enum PostalDeliveryType {
  CARE_OF_POST_OFFICE = "CARE_OF_POST_OFFICE",
  COMMUNITY_MAIL_AGENT = "COMMUNITY_MAIL_AGENT",
  COMMUNITY_MAIL_BAG = "COMMUNITY_MAIL_BAG",
  COMMUNITY_POSTAL_AGENT = "COMMUNITY_POSTAL_AGENT",
  GPO_BOX = "GPO_BOX",
  LOCKED_BAG = "LOCKED_BAG",
  MAIL_SERVICE = "MAIL_SERVICE",
  PO_BOX = "PO_BOX",
  PRIVATE_BAG = "PRIVATE_BAG",
  ROADSIDE_DELIVERY = "ROADSIDE_DELIVERY",
  ROADSIDE_MAIL_BAG = "ROADSIDE_MAIL_BAG",
  ROADSIDE_MAIL_SERVICE = "ROADSIDE_MAIL_SERVICE",
}

export enum StreetSuffix {
  CENTRAL = "CENTRAL",
  EAST = "EAST",
  EXTENSION = "EXTENSION",
  LOWER = "LOWER",
  NORTH = "NORTH",
  NORTH_EAST = "NORTH_EAST",
  NORTH_WEST = "NORTH_WEST",
  SOUTH = "SOUTH",
  SOUTH_EAST = "SOUTH_EAST",
  SOUTH_WEST = "SOUTH_WEST",
  UPPER = "UPPER",
  WEST = "WEST",
}

export enum StreetType {
  ACCESS = "ACCESS",
  ALLEY = "ALLEY",
  ALLEYWAY = "ALLEYWAY",
  AMBLE = "AMBLE",
  ANCHORAGE = "ANCHORAGE",
  APPROACH = "APPROACH",
  ARCADE = "ARCADE",
  ARTERY = "ARTERY",
  AVENUE = "AVENUE",
  BASIN = "BASIN",
  BEACH = "BEACH",
  BEND = "BEND",
  BLOCK = "BLOCK",
  BOULEVARD = "BOULEVARD",
  BRACE = "BRACE",
  BRAE = "BRAE",
  BREAK = "BREAK",
  BRIDGE = "BRIDGE",
  BROADWAY = "BROADWAY",
  BROW = "BROW",
  BYPASS = "BYPASS",
  BYWAY = "BYWAY",
  CAUSEWAY = "CAUSEWAY",
  CENTRE = "CENTRE",
  CENTREWAY = "CENTREWAY",
  CHASE = "CHASE",
  CIRCLE = "CIRCLE",
  CIRCLET = "CIRCLET",
  CIRCUIT = "CIRCUIT",
  CIRCUS = "CIRCUS",
  CLOSE = "CLOSE",
  COLONNADE = "COLONNADE",
  COMMON = "COMMON",
  CONCOURSE = "CONCOURSE",
  COPSE = "COPSE",
  CORNER = "CORNER",
  CORSO = "CORSO",
  COURT = "COURT",
  COURTYARD = "COURTYARD",
  COVE = "COVE",
  CRESCENT = "CRESCENT",
  CREST = "CREST",
  CROSS = "CROSS",
  CROSSING = "CROSSING",
  CROSSROAD = "CROSSROAD",
  CROSSWAY = "CROSSWAY",
  CRUISEWAY = "CRUISEWAY",
  CUL_DE_SAC = "CUL_DE_SAC",
  CUTTING = "CUTTING",
  DALE = "DALE",
  DELL = "DELL",
  DEVIATION = "DEVIATION",
  DIP = "DIP",
  DISTRIBUTOR = "DISTRIBUTOR",
  DRIVE = "DRIVE",
  DRIVEWAY = "DRIVEWAY",
  EDGE = "EDGE",
  ELBOW = "ELBOW",
  END = "END",
  ENTRANCE = "ENTRANCE",
  ESPLANADE = "ESPLANADE",
  ESTATE = "ESTATE",
  EXPRESSWAY = "EXPRESSWAY",
  EXTENSION = "EXTENSION",
  FAIRWAY = "FAIRWAY",
  FIRETRAIL = "FIRETRAIL",
  FIRE_TRACK = "FIRE_TRACK",
  FLAT = "FLAT",
  FOLLOW = "FOLLOW",
  FOOTWAY = "FOOTWAY",
  FORESHORE = "FORESHORE",
  FORMATION = "FORMATION",
  FREEWAY = "FREEWAY",
  FRONT = "FRONT",
  FRONTAGE = "FRONTAGE",
  GAP = "GAP",
  GARDEN = "GARDEN",
  GARDENS = "GARDENS",
  GATE = "GATE",
  GATES = "GATES",
  GLADE = "GLADE",
  GLEN = "GLEN",
  GRANGE = "GRANGE",
  GREEN = "GREEN",
  GROUND = "GROUND",
  GROVE = "GROVE",
  GULLY = "GULLY",
  HEIGHTS = "HEIGHTS",
  HIGHROAD = "HIGHROAD",
  HIGHWAY = "HIGHWAY",
  HILL = "HILL",
  INTERCHANGE = "INTERCHANGE",
  INTERSECTION = "INTERSECTION",
  JUNCTION = "JUNCTION",
  KEY = "KEY",
  LANDING = "LANDING",
  LANE = "LANE",
  LANEWAY = "LANEWAY",
  LEES = "LEES",
  LINE = "LINE",
  LINK = "LINK",
  LITTLE = "LITTLE",
  LOOKOUT = "LOOKOUT",
  LOOP = "LOOP",
  LOWER = "LOWER",
  MALL = "MALL",
  MEANDER = "MEANDER",
  MEW = "MEW",
  MEWS = "MEWS",
  MOTORWAY = "MOTORWAY",
  MOUNT = "MOUNT",
  NOOK = "NOOK",
  OUTLOOK = "OUTLOOK",
  PARADE = "PARADE",
  PARK = "PARK",
  PARKLANDS = "PARKLANDS",
  PARKWAY = "PARKWAY",
  PART = "PART",
  PASS = "PASS",
  PASSAGE = "PASSAGE",
  PATH = "PATH",
  PATHWAY = "PATHWAY",
  PIAZZA = "PIAZZA",
  PLACE = "PLACE",
  PLATEAU = "PLATEAU",
  PLAZA = "PLAZA",
  POCKET = "POCKET",
  POINT = "POINT",
  PORT = "PORT",
  PROMENADE = "PROMENADE",
  QUAD = "QUAD",
  QUADRANGLE = "QUADRANGLE",
  QUADRANT = "QUADRANT",
  QUAY = "QUAY",
  QUAYS = "QUAYS",
  RAMBLE = "RAMBLE",
  RAMP = "RAMP",
  RANGE = "RANGE",
  REACH = "REACH",
  RESERVE = "RESERVE",
  REST = "REST",
  RETREAT = "RETREAT",
  RIDE = "RIDE",
  RIDGE = "RIDGE",
  RIDGEWAY = "RIDGEWAY",
  RIGHT_OF_WAY = "RIGHT_OF_WAY",
  RING = "RING",
  RISE = "RISE",
  RIVER = "RIVER",
  RIVERWAY = "RIVERWAY",
  RIVIERA = "RIVIERA",
  ROAD = "ROAD",
  ROADS = "ROADS",
  ROADSIDE = "ROADSIDE",
  ROADWAY = "ROADWAY",
  RONDE = "RONDE",
  ROSEBOWL = "ROSEBOWL",
  ROTARY = "ROTARY",
  ROUND = "ROUND",
  ROUTE = "ROUTE",
  ROW = "ROW",
  RUE = "RUE",
  RUN = "RUN",
  SERVICE_WAY = "SERVICE_WAY",
  SIDING = "SIDING",
  SLOPE = "SLOPE",
  SOUND = "SOUND",
  SPUR = "SPUR",
  SQUARE = "SQUARE",
  STAIRS = "STAIRS",
  STATE_HIGHWAY = "STATE_HIGHWAY",
  STEPS = "STEPS",
  STRAND = "STRAND",
  STREET = "STREET",
  STRIP = "STRIP",
  SUBWAY = "SUBWAY",
  TARN = "TARN",
  TERRACE = "TERRACE",
  THOROUGHFARE = "THOROUGHFARE",
  TOLLWAY = "TOLLWAY",
  TOP = "TOP",
  TOR = "TOR",
  TOWERS = "TOWERS",
  TRACK = "TRACK",
  TRAIL = "TRAIL",
  TRAILER = "TRAILER",
  TRIANGLE = "TRIANGLE",
  TRUNKWAY = "TRUNKWAY",
  TURN = "TURN",
  UNDERPASS = "UNDERPASS",
  UPPER = "UPPER",
  VALE = "VALE",
  VIADUCT = "VIADUCT",
  VIEW = "VIEW",
  VILLAS = "VILLAS",
  VISTA = "VISTA",
  WADE = "WADE",
  WALK = "WALK",
  WALKWAY = "WALKWAY",
  WAY = "WAY",
  WHARF = "WHARF",
  WYND = "WYND",
  YARD = "YARD",
}

export enum UnitType {
  APARTMENT = "APARTMENT",
  COTTAGE = "COTTAGE",
  DUPLEX = "DUPLEX",
  FACTORY = "FACTORY",
  FLAT = "FLAT",
  HOUSE = "HOUSE",
  KIOSK = "KIOSK",
  MAISONETTE = "MAISONETTE",
  MARINE_BERTH = "MARINE_BERTH",
  OFFICE = "OFFICE",
  PENTHOUSE = "PENTHOUSE",
  REAR = "REAR",
  ROOM = "ROOM",
  SHED = "SHED",
  SHOP = "SHOP",
  SITE = "SITE",
  STALL = "STALL",
  STUDIO = "STUDIO",
  SUITE = "SUITE",
  TOWNHOUSE = "TOWNHOUSE",
  UNIT = "UNIT",
  VILLA = "VILLA",
  WARD = "WARD",
  WAREHOUSE = "WAREHOUSE",
}

export interface AustralianAddressInput {
  postBoxNumber?: string | null;
  postBoxType?: PostalDeliveryType | null;
  levelNumber?: string | null;
  levelType?: LevelType | null;
  unitNumber?: string | null;
  unitType?: UnitType | null;
  buildingName?: string | null;
  lotNumber?: string | null;
  streetNumber?: string | null;
  streetNumberLast?: string | null;
  streetNumberSuffix?: string | null;
  streetName?: string | null;
  streetType?: StreetType | null;
  streetSuffix?: StreetSuffix | null;
  locality?: string | null;
  postcode?: string | null;
  state?: AustralianStateCode | null;
  dpid?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
